
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Forceurbaniarentalinwagholipune() {



    const cardData =
    {
        keyword: 'Force Urbania Rental in Wagholi Pune  ',
        heading: 'Amruta Travels: Force Urbania Rental in Wagholi Pune ',
        headingDescription: 'Amruta Travels offers Force Urbania Rental in Wagholi Pune, providing a comfortable and reliable transportation solution for corporate travel, family trips, airport transfers, school outings, and outstation tours. Our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities for a smooth and enjoyable journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels ensures safe, convenient, and hassle-free Force Urbania rentals in Wagholi Pune.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Force Urbania rental in Wagholi Pune",
    "description": "Force Urbania rental in Wagholi Pune offering premium and comfortable group travel solutions. Ideal for corporate travel, family outings, airport transfers, weddings, and outstation trips with fully air-conditioned interiors, plush pushback seats, ample legroom, large luggage space, clean cabins, and professional drivers ensuring a smooth and safe journey every time."
  },
  {
    "name": "Urbania on rent in Wagholi",
    "description": "Urbania on rent in Wagholi Pune for luxury and reliable transportation. Suitable for daily travel, long-distance tours, and special occasions, featuring AC comfort, spacious seating layout, modern interiors, and experienced chauffeurs familiar with Wagholi and nearby areas."
  },
  {
    "name": "Urbania Bus hire Wagholi Pune",
    "description": "Urbania Bus hire in Wagholi Pune for group travel needs including corporate events, family trips, weddings, and tours. Enjoy smooth rides with AC interiors, comfortable seating, strong suspension, and trained drivers for city and highway travel."
  },
  {
    "name": "Force Urbania on Rent Wagholi",
    "description": "Force Urbania on rent in Wagholi providing luxury mini bus services for small and medium groups. Designed for comfort with air-conditioning, wide seats, ample luggage space, and courteous drivers ensuring punctual and stress-free journeys."
  },
  {
    "name": "Urbania Rental Service Wagholi",
    "description": "Urbania rental service in Wagholi offering dependable and affordable transportation for all travel purposes. Vehicles are well-maintained with AC interiors, clean seating, sufficient luggage space, and professional drivers."
  },
  {
    "name": "13 seater Urbania on rent Wagholi",
    "description": "13 seater Urbania on rent in Wagholi perfect for family trips, airport transfers, and corporate travel. Comes with AC interiors, comfortable pushback seating, safety features, and experienced chauffeurs."
  },
  {
    "name": "17 seater Urbania rental Wagholi",
    "description": "17 seater Urbania rental in Wagholi ideal for larger groups and corporate teams. Luxury AC interiors, spacious seating configuration, ample luggage space, and smooth ride quality ensure premium group travel."
  },
  {
    "name": "Luxury Urbania hire Wagholi",
    "description": "Luxury Urbania hire in Wagholi for premium travel experiences. Best suited for executives, weddings, and VIP guests with high-end AC interiors, plush seating, elegant design, and professional drivers."
  },
  {
    "name": "AC Urbania Bus Rental Wagholi",
    "description": "AC Urbania bus rental in Wagholi delivering cool, comfortable, and relaxed journeys. Ideal for all seasons with powerful air-conditioning, clean interiors, comfortable seating, and reliable service."
  },
  {
    "name": "Force Urbania 17 seater Wagholi",
    "description": "Force Urbania 17 seater in Wagholi for corporate events, family outings, and outstation tours. Features AC comfort, wide legroom, luggage capacity, and skilled drivers for long-distance travel."
  },
  {
    "name": "Urbania on rent near Wagholi Pune",
    "description": "Urbania on rent near Wagholi Pune with quick availability and doorstep pickup. Ideal for IT professionals, families, and tourists looking for luxury, comfort, and timely service."
  },
  {
    "name": "Urbania Bus Hire Near Lonikand",
    "description": "Urbania bus hire near Lonikand for group transportation needs. Suitable for rural and highway travel with AC interiors, spacious seating, and experienced drivers familiar with local routes."
  },
  {
    "name": "Urbania rental near Kharadi Wagholi",
    "description": "Urbania rental near Kharadi Wagholi catering to corporate offices, IT parks, and residential areas. Offers AC luxury vehicles, comfortable seating, punctual service, and professional chauffeurs."
  },
  {
    "name": "Urbania Bus hire near Viman Nagar",
    "description": "Urbania bus hire near Viman Nagar for airport transfers and city travel. Spacious AC interiors, ample luggage space, and drivers experienced with airport routes ensure hassle-free travel."
  },
  {
    "name": "Urbania rental Wagholi for corporate travels",
    "description": "Urbania rental in Wagholi for corporate travel including meetings, conferences, seminars, and employee transport. Premium AC interiors, disciplined drivers, and reliable service meet corporate standards."
  },
  {
    "name": "Urbania hire Wagholi for airport transfer",
    "description": "Urbania hire in Wagholi for airport transfers with punctual pickup and drop services. AC comfort, luggage-friendly design, and experienced drivers ensure stress-free airport journeys."
  },
  {
    "name": "Urbania on rent Wagholi for family trip",
    "description": "Urbania on rent in Wagholi for family trips offering safety, comfort, and space. Ideal for outings and vacations with AC interiors, cushioned seating, and smooth ride quality."
  },
  {
    "name": "Urbania rental Wagholi for outstation",
    "description": "Urbania rental in Wagholi for outstation travel to Lonavala, Mahabaleshwar, Shirdi, Mumbai, and more. Comfortable AC interiors, reliable vehicles, and experienced drivers ensure relaxed long-distance journeys."
  },
  {
    "name": "Urbania van hire Wagholi for wedding",
    "description": "Urbania van hire in Wagholi for wedding transportation. Perfect for guest movement and family travel with luxury AC interiors, spacious seating, and professional chauffeurs."
  },
  {
    "name": "Urbania on rent near Pune Airport",
    "description": "Urbania on rent near Pune Airport for smooth airport transfers and guest pickups. Offers AC luxury vehicles, ample luggage space, and drivers well-versed with airport timings and routes."
  },
  {
    "name": "Force Urbania rental Wagholi price",
    "description": "Force Urbania rental price in Wagholi offering transparent and competitive pricing. Cost-effective packages with premium AC vehicles, professional drivers, and dependable service."
  },
  {
    "name": "Urbania hire Wagholi per km rate",
    "description": "Urbania hire in Wagholi available on per km basis for flexible travel needs. Ideal for local and outstation trips with affordable rates, AC comfort, and reliable vehicles."
  },
  {
    "name": "Affordable Urbania rental Wagholi",
    "description": "Affordable Urbania rental in Wagholi providing luxury travel at budget-friendly prices. Maintained vehicles, AC interiors, and professional drivers ensure great value for money."
  },
  {
    "name": "Cheap Urbania on rent Wagholi",
    "description": "Cheap Urbania on rent in Wagholi for cost-conscious travelers. Offers economical pricing without compromising on AC comfort, safety, and service quality."
  },
  {
    "name": "Best Urbania rental service Wagholi",
    "description": "Best Urbania rental service in Wagholi known for reliability, comfort, and customer satisfaction. Premium AC vehicles, experienced drivers, punctual service, and flexible booking options."
  }
],
"tableData": [
  ["Force Urbania rental in Wagholi Pune", "Urbania on rent in Wagholi"],
  ["Urbania Bus hire Wagholi Pune", "Force Urbania on Rent Wagholi"],
  ["Urbania Rental Service Wagholi", "13 seater Urbania on rent Wagholi"],
  ["17 seater Urbania rental Wagholi", "Luxury Urbania hire Wagholi"],
  ["AC Urbania Bus Rental Wagholi", "Force Urbania 17 seater Wagholi"],
  ["Urbania on rent near Wagholi Pune", "Urbania Bus Hire Near Lonikand"],
  ["Urbania rental near Kharadi Wagholi", "Urbania Bus hire near Viman Nagar"],
  ["Urbania rental Wagholi for corporate travels", "Urbania hire Wagholi for airport transfer"],
  ["Urbania on rent Wagholi for family trip", "Urbania rental Wagholi for outstation"],
  ["Urbania van hire Wagholi for wedding", "Urbania on rent near Pune Airport"],
  ["Force Urbania rental Wagholi price", "Urbania hire Wagholi per km rate"],
  ["Affordable Urbania rental Wagholi", "Cheap Urbania on rent Wagholi"],
  ["Best Urbania rental service Wagholi", "Luxury Urbania hire Wagholi"]
],




"whychoose": [
  {
    "WhyChooseheading": "Trusted Force Urbania Rental in Wagholi Pune",
    "WhyChoosedescription": "Amruta Travels offers Force Urbania Rental in Wagholi Pune, providing a comfortable, stylish, and reliable travel solution for group travel, corporate trips, and family outings."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Family, and Event Travel",
    "WhyChoosedescription": "Whether it’s a corporate meeting, office commute, family trip, wedding transport, or VIP movement, our Force Urbania rentals from Wagholi ensure smooth and comfortable travel."
  },
  {
    "WhyChooseheading": "Spacious and Luxurious Interiors",
    "WhyChoosedescription": "The Force Urbania features plush seating, ample legroom, air conditioning, large windows, and generous luggage space, making it perfect for short trips and long-distance journeys."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All Force Urbania rentals include trained and courteous drivers who ensure punctuality, safety, and a stress-free travel experience across Wagholi, Pune, and beyond."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Amruta Travels offers transparent and competitive pricing for Force Urbania rental in Wagholi Pune, ensuring excellent value for money without hidden costs."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "Our Force Urbania vehicles are regularly serviced and sanitized, maintaining high standards of hygiene, safety, and comfort for every trip."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Route Planning",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations along with customized routes to suit your travel plan within Wagholi, Pune, or outstation destinations."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking a Force Urbania Rental in Wagholi Pune is simple and hassle-free with Amruta Travels. Our support team assists you at every step for a seamless experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book Force Urbania rental in Wagholi Pune?',
    answer: 'You can book Force Urbania rental in Wagholi Pune by contacting Amruta Travels online, via phone, or by visiting our office. Our team will assist you with the booking process.'
  },
  {
    question: 'Is Force Urbania suitable for corporate travel from Wagholi?',
    answer: 'Yes, Force Urbania is ideal for corporate travel, offering spacious seating, air conditioning, and comfort for employees and clients traveling from Wagholi.'
  },
  {
    question: 'Can I rent Force Urbania in Wagholi for outstation trips?',
    answer: 'Yes, we provide Force Urbania rentals from Wagholi for both local and outstation travel, ensuring a smooth and comfortable journey.'
  },
  {
    question: 'Does the Force Urbania rental include a driver?',
    answer: 'Yes, every Force Urbania rental includes a professional and experienced driver for safe and hassle-free travel.'
  },
  {
    question: 'Are the Force Urbania vehicles well-maintained?',
    answer: 'Absolutely. All Force Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain safety, hygiene, and comfort.'
  },
  {
    question: 'What is the cost of Force Urbania rental in Wagholi Pune?',
    answer: 'The rental cost depends on distance, duration, and travel type. Contact Amruta Travels for a transparent and customized quote.'
  },
  {
    question: 'Can I customize pickup and drop-off locations in Wagholi?',
    answer: 'Yes, we offer flexible pickup and drop-off options and route customization as per your travel needs.'
  },
  {
    question: 'Why choose Amruta Travels for Force Urbania rental in Wagholi Pune?',
    answer: 'Amruta Travels offers well-maintained Force Urbania vehicles, professional drivers, transparent pricing, and reliable support, ensuring a premium travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rahul Bhosale',
    role: 'Business Owner, Wagholi',
    text: 'We rented a Force Urbania from Wagholi for a corporate trip. The vehicle was clean, comfortable, and the driver was very professional. Excellent service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Pooja Kharat',
    role: 'Family Traveler, Wagholi',
    text: 'Booked a Force Urbania rental in Wagholi for a family outing. The ride was smooth and comfortable. Highly recommend Amruta Travels!',
    rating: 5
  }
];






















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const schemaData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "LocalBusiness",
      "name": "Amruta Travels",
      "image": "https://bushireinpune.com/assets/images/force-urbania-rental-wagholi.jpg",
      "url": "https://bushireinpune.com/force-urbania-rental-wagholi",
      "telephone": "+91 7353109555",
      "priceRange": "₹₹",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Wagholi",
        "addressRegion": "Maharashtra",
        "addressCountry": "IN"
      },
      "areaServed": [
        { "@type": "Place", "name": "Wagholi" },
        { "@type": "Place", "name": "Kharadi" },
        { "@type": "Place", "name": "Viman Nagar" },
        { "@type": "Place", "name": "Lonikand" }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "7520"
      }
    },
    {
      "@type": "Service",
      "serviceType": "Force Urbania Rental Wagholi Pune",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Amruta Travels"
      },
      "areaServed": {
        "@type": "Place",
        "name": "Wagholi Pune"
      },
      "description": "Book Force Urbania rental in Wagholi Pune for airport transfer, corporate travel, family trips and outstation journeys."
    },
    {
      "@type": "Product",
      "name": "Force Urbania Rental in Wagholi Pune",
      "image": "https://bushireinpune.com/assets/images/force-urbania-rental-wagholi.jpg",
      "description": "Hire 13 and 17 seater Force Urbania in Wagholi Pune with AC, pushback seats and experienced drivers at best price.",
      "brand": {
        "@type": "Brand",
        "name": "Amruta Travels"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "7520"
      },
      "offers": {
        "@type": "Offer",
        "priceCurrency": "INR",
        "price": "6100",
        "availability": "https://schema.org/InStock",
        "url": "https://bushireinpune.com/force-urbania-rental-wagholi"
      }
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Is Urbania available in Wagholi Pune?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Urbania rental is available in Wagholi, Kharadi, Viman Nagar and nearby areas."
          }
        },
        {
          "@type": "Question",
          "name": "What is the price of Urbania in Wagholi Pune?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Urbania rental starts from ₹6100 depending on trip and seating capacity."
          }
        },
        {
          "@type": "Question",
          "name": "Can I book Urbania for airport transfer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Urbania is available for Pune Airport and Mumbai Airport transfers."
          }
        }
      ]
    }
  ]
};




    return (
        <div>

<Helmet>
  <title>
    Force Urbania Rental in Wagholi Pune | Urbania Hire Near Kharadi Airport | Call 7353109555
  </title>

  <meta
    name="description"
    content="Book Force Urbania rental in Wagholi Pune near Kharadi & Viman Nagar. Hire 13 & 17 seater Urbania vans for airport transfer, corporate travel, weddings & Pune to Mumbai, Goa, Shirdi trips."
  />

  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/111.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Forceurbaniarentalinwagholipune;